export interface MacroGoals {
  id?: number;
  userId?: number;
  from?: string | null;
  to?: string | null;
  calories: number;
  carbs: number;
  fats: number;
  protein: number;
}

export const emptyMacroGoals = (): MacroGoals => ({
  calories: 0,
  carbs: 0,
  fats: 0,
  protein: 0,
});

export const resolveMacroGoals = (
  macros: Array<Partial<MacroGoals>> | null | undefined
): MacroGoals | null => {
  if (!macros?.length) {
    return null;
  }

  const activeMacros = macros.find((macro): boolean => macro.to == null);
  if (!activeMacros) {
    return null;
  }

  return {
    id: activeMacros.id,
    userId: activeMacros.userId,
    from: activeMacros.from ?? null,
    to: activeMacros.to ?? null,
    calories: activeMacros.calories ?? 0,
    carbs: activeMacros.carbs ?? 0,
    fats: activeMacros.fats ?? 0,
    protein: activeMacros.protein ?? 0,
  };
};
